import React from "react";
import ContactForm from "../../components/contakt";

const Contact = () => {
  return (
    <div>
      <ContactForm />
    </div>
  );
};

export default Contact;
